import { render, staticRenderFns } from "./common_chat_emoji.vue?vue&type=template&id=9e882aaa"
import script from "./common_chat_emoji.vue?vue&type=script&lang=js"
export * from "./common_chat_emoji.vue?vue&type=script&lang=js"
import style0 from "./common_chat_emoji.vue?vue&type=style&index=0&id=9e882aaa&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports